module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/011-06d7a731e639990d05295e2f0b3e80fd.jpg";